import * as React from 'react'
import classes from './accountLink.module.scss';
import clsx from "clsx";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import {Typography} from "@mui/material";
import Button from '../../common/Button';
import {SignInDialog} from "../sign-in/SignInDialog";
import AccountMenu from "./AccountMenu";
import useCurrentUser from "../../hooks/useCurrentUser";

export const AccountLink = () => {
  const user = useCurrentUser();
  const [signInOpen, setSignInOpen] = React.useState(false);
  const [accountMenuOpen, setAccountMenuOpen] = React.useState(false);

  const handleSignInClose = () => {
    setSignInOpen(false);
  }

  const handleAccountMenuClose = () => {
    setAccountMenuOpen(false);
  }

  if(user) {
    return <>
      <Button
        variant="outlined"
        color="inherit"
        className={clsx('jc-account-button', 'jc-flex', 'jc-justify-center', classes.accountLinkButton)}
        onClick={() => setAccountMenuOpen(!accountMenuOpen)}
      >
        <AccountCircleOutlinedIcon className={classes.buttonColor} />
        <Typography component="div" variant="body2" className={classes.buttonColor}>My account</Typography>
      </Button>
      <AccountMenu open={accountMenuOpen} onClose={handleAccountMenuClose} />
    </>
  } else {
    return <>
      <Button
        variant="outlined"
        color="inherit"
        className={clsx('jc-account-button', 'jc-flex', 'jc-justify-center', classes.accountLinkButton)}
        onClick={() => {setSignInOpen(true)}}
      >
        <AccountCircleOutlinedIcon className={classes.buttonColor} />
        <Typography component="div" variant="body2" className={classes.buttonColor}>Sign in</Typography>
      </Button>
      <SignInDialog open={signInOpen} handleClose={handleSignInClose} onSuccess={() => window.location.reload()} />
    </>
  }

}

export default AccountLink;